import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogData } from '@Components/ui/confirm-dialog/confirm-dialog.component';
import { FormComponent } from '@Components/ui/form/form.component';
import { ListComponent } from '@Components/ui/list/list.component';
import { AdfiUtil } from '@Components/util/adfi-util';
import { ICustomComponent } from '@Components/util/ICustomComponent';
import { Property, DataEntity, PeriodState, ENUM_ACTIONS, PropertyTypes } from '@Interfaces/index';
import { AdfiGraphqlService } from '@services/adfi-graphql.service';
import { AdfiGrowlService } from '@services/adfi-growl.service';
import { AdfiService } from '@services/adfi-service';
import { LoadingService } from '@services/loading.service';

@Component({
  selector: 'app-relate-assets',
  templateUrl: './relate-assets.component.html',
  styleUrls: ['./relate-assets.component.scss']
})
export class RelateAssetsComponent implements OnInit, ICustomComponent {
  @ViewChild('assets') assetsTable: ListComponent;
  @Output() reloadData: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private adfiService: AdfiService,
    private matDialog: MatDialog,
    private adfiGrowlService: AdfiGrowlService,
    private graphqlService: AdfiGraphqlService,
    private loading: LoadingService

  ) { }
  field: Property;
  dataEntity: DataEntity;
  group: string;
  item: any;
  block: boolean;
  canAdd: boolean;
  openForm = false;
  ppyeIncome: any;
  showHistory = false;
  isLoading = true;
  certificateId: any;
  totalAsset: number = 0;
  availableBalance: number = 0;

  setConfig(field: Property, dataEntity: DataEntity, group: string, item: any) {
    this.field = field;
    this.dataEntity = dataEntity;
    this.group = group;
    this.item = item;
  }

  async ngOnInit() {
    this.block = this.adfiService.validPermission('BlockingPlatform', 'lock', PeriodState.NO_STATUS);
    if (!this.block) {
      this.canAdd = this.adfiService.validPermission('PpyeIncome', 'add', PeriodState.OPEN);
    }
    this.getIncome();
  }

  addItem() {
    this.openForm = true;
  }

  async close() {
    this.openForm = false;
    this.reload();
  }

  async reload() {
    this.reloadData.emit(true);
  }

  request() {
    const data: ConfirmDialogData = {
      title: 'Solicitar Aprobación',
      content: 'Por favor verifique que la información ingresada sea correcta. <br><b>La veracidad de los datos registrados es <u>responsabilidad</u> del usuario.</b>',
      action: ENUM_ACTIONS.EDIT
    };
    const dialog = this.matDialog.open(ConfirmDialogComponent, {
      data
    });
    dialog.afterClosed().subscribe(async (ok) => {
      if (ok) {
        this.loading.show();
        const next = async (response) => {
          if (response.state === 'P') {
            this.loading.hide();
            this.adfiGrowlService.success('Correcto', 'Solicitud realizada correctamente correctamente');
            this.reload();

          } else {
            this.loading.hide();
            this.adfiGrowlService.error('Error', 'No se pudo realizar la solicitud.');
          }
        };
        const error = (e) => {
          this.loading.hide();
          this.adfiGrowlService.errorMessage(e);
        };
        this.graphqlService.updateEntity(
          "PpyeIncome",
          {
            id: this.item.id,
            state: 'P'
          },
          'state',
          { next, error }
        );
      }
    });
  }
   async getIncome() {
    const next = (data) => {
      this.ppyeIncome = data;
    };
    const error = (e) => {
      this.adfiGrowlService.errorMessage(e, 'Error al cargar la información.');
    };
    this.graphqlService.getOneEntity("ppyeIncome", "totalValue", this.item.id, undefined, { next, error });
  }

  generateCertificate() {
    this.loading.show();
    if (this.group === 'REPOSICION') {
      this.selectOficial();
      return;
    }
    let certificateType = '';
    if (this.group === 'DONACION') {
      certificateType = 'ID';
    } else if (this.group === 'REPOSICION') {
      certificateType = 'RP';
    } else if (this.group === 'DOTACION') {
      certificateType = 'IT';
    } else if (this.group === 'COMODATO') {
      certificateType = 'IC';
    } else if (this.group === 'TRASPASO') {
      certificateType = 'TR';
    }

    const period = this.adfiService.periods.find(p => p.estado === "A");
    const now = period.year < (new Date()).getFullYear() ? new Date(period.year, 11, 30) : new Date();
    now.setHours(0, 0, 0, 0);

    const nameClass = 'generateCertificate';
    const filters = JSON.stringify({ incomeId: this.item._id, certificateType: certificateType });
    const actions = '';
    const message = this.item.objectIncome;

    const next = (response) => {
      if (response) {
        this.adfiGrowlService.success('Correcto', 'Acta de recibido satisfación generada correctamente');
        this.reload();
      }
      this.loading.hide();
    };
    const error = (err) => {
      this.loading.hide();
      this.adfiGrowlService.errorMessage(err, 'Error en la creación del acta');
    };
    this.graphqlService.createEntity('Action',{ nameClass, filters, actions, message }, 'message actions', { next, error });

  }

  selectOficial() {
    const period = this.adfiService.periods.find(p => p.estado === "A");
    const now = period.year < (new Date()).getFullYear() ? new Date(period.year, 11, 30) : new Date();
    const customData: any = {
      certificateDate: now.toUTCString(),
      certificateType: 'RP',
      objectCertificate: this.item.objectIncome,
      assetsRelated: this.item.assets.edges.filter(d => d.node.isActive).map(d => {
        return d.node.id;
      }),
      source: true
    };
    const dialog = this.matDialog.open(FormComponent, {
      data: {
        entityName: 'CertificatesAsset',
        module: 'MovimientoBienes',
        group: 'GI',
        customData,
        customTitle: 'Generar Acta de Recibido Satisfacción',
        action: ENUM_ACTIONS.CREATE
      } as DataEntity
    });
    const subs = dialog.beforeClosed().subscribe((event) => {
      if (event) {
        this.reload();
      }
    });
  }

  getTotalAsset() {
    if (this.item.state === 'A' || this.item.state === 'C') {
      if (!this.certificateId && this.assetsTable) {
       this.certificateId = this.assetsTable.data.find(
         item => !item.isGroup && item.cancellationDate == null
       );
       const types = ['ID','RP','IT','IC','RC','TR'];
      this.certificateId = this.certificateId.assetsCertificates.edges.find(
        item =>
          item.node.dateAnnulment == null &&
          types.includes(item.node.certificateType)
      )?.node._id;
      }
    }

    const next = (d) => {
        this.totalAsset = d.total;
        this.calculateAvailability();
        this.isLoading = false;
      };
      const error = (e) => {
          this.adfiGrowlService.errorMessage(e);
      };
      this.graphqlService.createEntity('Summation', {
          nameClass: 'MovimientoBienes\\PpyeIncome',
          filters: JSON.stringify({id: this.item._id}),
          actions: 'value',
      }, 'total', {next, error});
  }

  format(value): string {
    return AdfiUtil.formatText(value, PropertyTypes.CURRENCY);
  }

  calculateAvailability() {
    this.availableBalance = Number((this.ppyeIncome?.totalValue - this.totalAsset).toFixed(2));
  }


}
